<template>
  <b-container id="body-container" fluid>
    <b-row class="justify-content-center row-white">
      <b-col md="12" class="body-home">
        <h2 class="title text-center">
          Spend more time closing, not searching
        </h2>
      </b-col>
      <b-col md="6" class="body-text-section">
        <h2 class="section-title text-left" style="padding-bottom:8px">
          Keep Your CRM Reliable
        </h2>
        <h2 class="section-sub-title text-left">
          5% or your CRM goes bad each month. Timely, personalized conversations
          build trust that leads to sales. Include 3+ accurate personalized
          details in your outreach for maximum success.
        </h2>
        <a
          href="https://www.getrocketsignals.com/clean-your-crm"
          class="button-padding"
        >
          <b-button class="button-white-transparent">Clean Your CRM</b-button>
        </a>
      </b-col>
      <b-col md="6" class="mt-md-5">
        <img src="../../assets/home/keepCRM.svg" alt="" />
      </b-col>
    </b-row>

    <b-row class="justify-content-center row-light">
      <b-col cols="10">
        <b-row>
          <img
            class="col-md-6"
            alt="customer success "
            src="../../assets/home/clients-land-expand.svg"
          />

          <b-col md="6" class="mt-md-4 body-text-section-right">
            <h2 class="section-title text-left">Expand Your Account Value</h2>
            <h2 class="section-sub-title text-left">
              Help Your Customer Success Team Increase Average Customer Value &
              Grow into new departments within your current customers.
            </h2>
            <a
              href="https://getrocketsignals.com/recipe-list"
              class="button-padding"
            >
              <b-button class="button-white-transparent">Get Started</b-button>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="justify-content-center row-white">
      <b-col md="6" class="body-text-section">
        <h2 class="section-title text-left" style="padding-bottom:8px">
          Perfectly Time Prospecting Efforts
        </h2>
        <h2 class="section-sub-title text-left">
          Congratulate New Hires and help them on their Hero's Journey. No one
          says no to a new hire … that’s a rule of life. (New Hire Signals)
        </h2>
        <a href="https://getrocketsignals.com/demo" class="button-padding">
          <b-button class="button-white-transparent">Request Demo</b-button>
        </a>
        <a
          href="https://getrocketsignals.com/company-filter"
          class="button-padding"
        >
          <b-button class="button-white-transparent">Get Started</b-button>
        </a>
      </b-col>
      <b-col md="6" class="mt-md-5">
        <img src="../../assets/home/new-hire.png" alt="" />
      </b-col>
    </b-row>
    <b-row class="justify-content-center row-light">
      <b-col cols="10">
        <b-row>
          <img
            class="col-md-4"
            alt="customer success "
            src="../../assets/home/track-rapidly.svg"
          />

          <b-col md="8" class="mt-md-4 body-text-section-right">
            <h2 class="section-title text-left">
              Track When Companies have and will be Funded (Funding Signals)
            </h2>
            <h2 class="section-sub-title text-left">
              1000+ companies receive funding each month. They are ready for
              growth, and they need new products and services to power their
              teams.
            </h2>
            <a
              href="https://getrocketsignals.com/funding-signal"
              class="button-padding"
            >
              <b-button class="button-white-transparent">Get Signals</b-button>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="justify-content-center row-white">
      <b-col md="6" class="body-text-section">
        <h2 class="section-title text-left" style="padding-bottom:8px">
          Track the fastest the growing companies
        </h2>
        <h2 class="section-sub-title text-left">
          We Monitor over 1 million companies every month to find if they are
          ripe for investment and prospecting.
        </h2>
      </b-col>
      <b-col md="6" class="mt-md-5">
        <img src="../../assets/home/growing.svg" alt="" />
      </b-col>
      <a href="https://getrocketsignals.com/demo" class="button-padding">
        <b-button class="button-white-transparent">Get a Demo</b-button>
      </a>
    </b-row>

    <!--


    <b-row class="justify-content-center row-white">
      <b-col cols="10">

        <b-row>

          <b-col md="6" class="mt-md-4" id="body-image-section-left">
             <img class="section-image" alt="gravity logo" src="../../assets/fast-growing.png" />
           </b-col>

          <b-col md="6" class="mt-md-4" id="body-text-section-right">
            <h2 class="section-title text-left">Track the fastest <br>growing accounts</h2>
            <h2 class="section-sub-title text-left">If they can afford more employees they can afford products</h2>
              <a href="/recipes/track-fast-growing-companies">
                <b-button class="button-white-transparent">Get Started</b-button>
              </a>
          </b-col>

        </b-row>

      </b-col>
    </b-row>



     <b-row class="justify-content-center row-purple">
      <b-col cols="10">

        <b-row>
          <b-col md="6" class="mt-md-4" id="body-text-section">
            <h2 class="section-title text-left">Track recently <br>funded accounts</h2>
            <h2 class="section-sub-title text-left">Investors expect growth, invest your time in vetted growing companies</h2>
              <a href="/recipes/track-recently-funded-companies">
                <b-button class="button-white-transparent">Get Started</b-button>
              </a>
          </b-col>

          <b-col md="6" class="mt-md-4" id="body-image-section">
             <img class="section-image" alt="gravity logo" src="../../assets/invest.png" />
           </b-col>

        </b-row>


      </b-col>
    </b-row>


    <b-row class="justify-content-center row-white">
      <b-col cols="10">

        <b-row>

          <b-col md="6" class="mt-md-4" id="body-image-section-left">
             <img class="section-image" alt="gravity logo" src="../../assets/automate.png" />
           </b-col>

          <b-col md="6" class="mt-md-4" id="body-text-section">
            <h2 class="section-title text-left">Track look-a-like accounts</h2>
            <h2 class="section-sub-title text-left">Monitor accounts similar to your best existing customers. Apply the 80/20 rule with our account prediction AI.</h2>
              <a>
                <b-button class="button-white-transparent">Get Started</b-button>
              </a>
          </b-col>

        </b-row>

      </b-col>
    </b-row>
    -->

    <b-row class="justify-content-center row-white">
      <b-col cols="10">
        <b-row align-h="start" id="body-home">
          <b-col md="12">
            <h2 class="title text-center" style="padding-bottom:60px">
              Trusted by the world’s most advanced sales & marketing teams
            </h2>
          </b-col>
        </b-row>

        <!--
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="4">
            <span>
              <h4 class="text-blackish title-body" id="fleet"> Recipes:</h4>
            </span>
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        -->

        <!--
        <div class="decorator2">
          <img alt="gravity logo" src="../../assets/decorator2.png" />
        </div>

        <b-row>
          <b-col
            v-for="guest of ourFleet"
            :key="guest.id"
            md="6"
            class="mt-md-4"
          >
            <ourFleet :guest="guest" />
          </b-col>
        </b-row>
        -->

        <!--
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="4">
            <span>
              <h4 class="text-blackish title-body" id="fleet">Shows:</h4>
            </span>
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        -->

        <div class="decorator2">
          <img alt="gravity logo" src="../../assets/decorator2.png" />
        </div>

        <b-row>
          <b-col md="2" sm="0"> </b-col>
          <b-col v-for="guest of ourShows" :key="guest.id" md="8" class="">
            <ourFleet :guest="guest" />
          </b-col>

          <b-col md="2" sm="0"> </b-col>
        </b-row>

        <!--
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="4">
            <span>
              <h4 class="text-blackish title-body" id="fleet">Founders:</h4>
            </span>
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        -->

        <!--

        <b-row class="pb-5">
          <b-col
            v-for="guest of ourFounders"
            :key="guest.id"
            md="6"
            class="mt-md-4"
          >
            <HostCard :guest="guest" />
          </b-col>
        </b-row>

        -->

        <!--
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="6">
            <span>
              <h4 class="text-blackish title-body">Join Our Next Livestream</h4>
            </span>
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        <div class="decorator1">
          <img alt="gravity logo" src="../../assets/decorator1.png" />
        </div>

        <MainCard :liveStream="liveStream" />
        -->
      </b-col>
    </b-row>

    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h2
                class="text-blackish cta-title"
                style="text-align:center; color:white"
              >
                Ready to supercharge your team?
              </h2>
            </span>
            <span>
              <b-row align-v="center" align-h="center">
                <h2
                  class="text-blackish cta-sub-title"
                  style="text-align:center; color:white;"
                >
                  We help teams start genuine conversations with timely openers
                </h2>
              </b-row>
            </span>
          </b-col>
        </b-row>

        <b-row class="">
          <b-col md="12" cols="12" class="buttons-close">
            <a
              href="https://getrocketsignals.com/demo"
              class="d-flex justify-content-center button-padding"
            >
              <b-button class="free-trial-button">Request Demo</b-button>
            </a>

            <!--
            <a
              href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
            >
              <b-button class="button-white-transparen"><b>Check our events</b></b-button>
            </a>
            -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass

.button-padding
  margin-top: 20px
  margin-right: 10px
  display: inline-block
</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
import ourFleet from "@/components/ourFleetCard";
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'

// data
import { guests, yourHosts } from "@/data/masters-of-marketing.js";

export default {
  name: "Body",
  components: {
    //MainCard,
    ourFleet,
    //ourFleetOG,
    // HostCard
  },
  data: function() {
    return {
      liveStream: {},
      featureSpeaker: [],
      pastSpeakers: [],
      futureSpeakers: [],
      guests,
      yourHosts,
      timeToShow: 10,
      timer: null,
      currentDate: null,
      dayOfWeek: null,
      month: 1,
      day: 1,
      year: 2020,
      speakerSelection: 1,
      liveRightNow: 0,

      ourFleet: [
        {
          id: 0,
          name: "Clean your dirty CRM",
          position:
            "85% of your company hates your CRM because 5% of your data goes bad every month.",
          title: "",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#2E1E85;box-shadow: 2px 10px 15px grey;",
          button: "Keep My CRM Actionable",
        },
        {
          id: 0,
          name: "Land & expand accounts",
          position:
            "Encouraging new hires to make friends with your best advocates. Sell between departments & increase usage",
          title: "Monitor who changes jobs into your target market each month",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#332296;box-shadow: 2px 10px 15px grey;",
          button: "Expand My Current Clients",
        },
        {
          id: 0,
          name: "Find new hires in your total addressable market",
          position:
            'New hires have the desire & authority to make an impact in their organization."No one says `No` to a new hire" - Guillaume "𝑮" Cabane',
          title: "Monitor who changes jobs into your target market each month",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#3926A6;box-shadow: 2px 10px 15px grey;",
          button: "Track New Hires",
        },
        {
          id: 0,
          name: "Track the fastest growing companies",
          position:
            "Fast growing companies have revenue or funding to afford employees. If you can afford employees you can afford products. ",
          title: "",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#3F2AB7;box-shadow: 2px 10px 15px grey;",
          button: "Track Fast Growing Accounts",
        },
        {
          id: 0,
          name: "Track recently funded companies",
          position:
            "50+ companies receive funding each month. They're ready for growth & need new tools to power their teams.",
          title: "Monitor who changes jobs into your target market each month",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#442DC8;box-shadow: 2px 10px 15px grey;",
          button: "Track Recently Funded Accounts",
        },
        {
          id: 0,
          name: "Uncover look-a-like companies",
          position:
            "Monitor accounts similar to your best existing customers. Apply the 80/20 rule with our account prediction AI.",
          title: "",
          subtitle: "Monitor Fresh Signals",
          speakingDate: "",
          linkedinURL: "https://www.getrocketsignals.com",
          photoFileName: "rocket-signals-logo.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#4F37D2;box-shadow: 2px 10px 15px grey;",
          button: "Track Look-a-like Accounts",
        },

        // {
        //   id: 0,
        //   name: 'Rocket Signals',
        //   position: '',
        //   title: 'Monitor who changes jobs into your target market each month',
        //   subtitle: 'Monitor Fresh Signals',
        //   speakingDate: '',
        //   linkedinURL: 'https://www.getrocketsignals.com',
        //   photoFileName: 'rocket-signals-logo.png',
        //   datePretty: '',
        //   daysLeft: 1,
        //   speakerStatus: 2,
        //   cardColor: 'background-color:#145BD2',
        // },
        // {
        //   id: 1,
        //   name: 'Little Black Book',
        //   position: '',
        //   title: 'Get email & phone number for any Linkedin profile you visit',
        //   subtitle: 'Free Chrome Extension',
        //   speakingDate: '',
        //   linkedinURL: 'https://www.getlittleblackbook.com',
        //   photoFileName: 'lbb-logo.png',
        //   datePretty: '',
        //   daysLeft: 0,
        //   speakerStatus: 0,
        //   cardColor: 'background-color:black',
        // }
      ],

      ourShows: [
        {
          id: 0,
          name:
            '"Rocket Signals are key. They power our sales reps to send timely gifts, start personalized conversations, and spend more time closing."',
          position: "",
          title: "15-minute Sales & Data Consulting",
          subtitle: "Season 1",
          speakingDate: "",
          linkedinURL: "/shows/crush-your-quota",
          photoFileName: "crush-your-quota.png",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#1D1353;box-shadow: 2px 10px 15px grey;",
        },
        /*
        {
          id: 0,
          name: 'Crush Your   Quota',
          position: '',
          title: '15-minute Sales & Data Consulting',
          subtitle: 'Season 1',
          speakingDate: '',
          linkedinURL: '/shows/crush-your-quota',
          photoFileName: 'crush-your-quota.png',
          datePretty: '',
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: 'background-color:#1737A1;box-shadow: 2px 10px 15px grey;',
        },
        {
          id: 1,
          name: 'Masters of Marketing',
          position: '',
          title: 'Marketing Insights from experienced consultants',
          subtitle: 'Season 1',
          speakingDate: '',
          linkedinURL: '/masters-of-marketing',
          photoFileName: 'mom-logo.png',
          datePretty: '',
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: 'background-color:#1C43C4;box-shadow: 2px 10px 15px grey;',
        },

        {
          id: 2,
          name: 'Fission Mail',
          position: '',
          title: 'Automate your outbound emails with personalized sequences',
          subtitle: 'Personalize at Scale',
          speakingDate: '',
          linkedinURL: 'https://www.getfissionmail.com',
          photoFileName: 'fission-mail-logo.png',
          datePretty: '',
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: 'background-color:#145BD2',
        },
        {
          id: 4,
          name: 'Alpha Voice',
          position: '',
          title: 'Automatically convert your YouTube & RSS to an Alexa Still.',
          subtitle: 'Lead Capture in Voice',
          speakingDate: '',
          linkedinURL: 'https://www.alphavoice.io',
          photoFileName: 'alpha-voice-logo.png',
          datePretty: '',
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: 'background-color:#26FBA1',
        },
        {
          id: 6,
          name: 'Booster (Beta)',
          position: '',
          title: 'Video marketing software that makes it easy to find and grow your audience.',
          subtitle: 'Capture Leads in-Video',
          speakingDate: '',
          linkedinURL: 'https://www.alphavoice.io',
          photoFileName: 'alpha-voice-logo.png',
          datePretty: '',
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: 'background-color:#141517',
        },
        */
      ],
      ourFounders: [
        {
          id: 0,
          name: "Ross Gates",
          position: "Co-Founder & Product Manager @ Gravity",
          title:
            "Buying-intent-signal consultant & data-driven product designer",
          subtitle: "",
          speakingDate: "",
          linkedinURL: "https://www.linkedin.com/in/rossegates/",
          photoFileName: "ross.jpeg",
          datePretty: "",
          daysLeft: 0,
          speakerStatus: 0,
          cardColor: "background-color:#221764;box-shadow: 2px 10px 15px grey;",
        },
        {
          id: 1,
          name: "Bryan Colligan",
          position: "Co-Founder & CTO @ Gravity",
          title: "3x Founder, Growth Hacker & Marketer",
          subtitle: "",
          speakingDate: "",
          linkedinURL: "https://www.linkedin.com/in/bryancolligan/",
          photoFileName: "bryan-purple.jpeg",
          datePretty: "",
          daysLeft: 1,
          speakerStatus: 2,
          cardColor: "background-color:#332296;box-shadow: 2px 10px 15px grey;",
        },
      ],
    };
  },
  computed: {
    timeLeft() {
      return `${this.minutes} m ${this.seconds} seconds`;
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, "0");
    },
    seconds() {
      return String(this.time % 60).padStart(2, "0");
    },
  },
  created() {
    this.orderSpeakers();
    this.setSpeakerRoles();
    //this.timeToShow = this.getTimeToShow(),
    //this.timer = setInterval(this.decrement, 1000)
  },
  methods: {
    orderSpeakers() {
      var currentDate = new Date();

      this.guests.forEach((guestItem, index) => {
        var speakingDate = guestItem.speakingDate;
        var year = parseInt(speakingDate.substr(0, 4));
        var month = parseInt(speakingDate.substr(5, 6)) - 1;
        var day = parseInt(speakingDate.substr(8, 9));
        var speakerDate = new Date(year, month, day, 0, 0, 0);
        var timeLeft = (speakerDate - currentDate) / 86400000;
        var daysLeft = Math.ceil(timeLeft);

        // Store the dates back into the array
        guestItem.daysLeft = timeLeft;
        var datePretty = speakerDate.toString().substr(0, 10);
        var ending = [
          "",
          "st",
          "nd",
          "rd",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "st",
          "nd",
          "rd",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "th",
          "st",
        ];
        if (ending[day] !== undefined) {
          datePretty += ending[day];
        } else {
          datePretty += "th";
        }
        guestItem.datePretty = datePretty;
        if (timeLeft < 1 && timeLeft > -0.082) {
          //this.featuredSpeaker = index
          guestItem.speakerStatus = 1; // featured
        } else if (
          timeLeft < 3 &&
          datePretty.substr(0, 3) === "Mon" &&
          timeLeft > -0.082
        ) {
          guestItem.speakerStatus = 1; // featured
        } else if (timeLeft < -0.082) {
          guestItem.speakerStatus = 0; // past
        } else {
          guestItem.speakerStatus = 2; // future
        }

        if (timeLeft < -0.041 && timeLeft > -0.082) {
          this.liveRightNow = 1;
        }

        console.log(timeLeft);
        console.log(datePretty);
        console.log(daysLeft);
        console.log(index);
      });
    },
    setSpeakerSelection(page) {
      this.speakerSelection = page;
    },
    setSpeakerRoles() {
      for (var i = 0; i < this.guests.length; i++) {
        if (this.guests[i].speakerStatus === 1) {
          console.log("Speaker Status");
          console.log(this.guests[i].speakerStatus);
          this.featureSpeaker.push(this.guests[i]);
        } else if (this.guests[i].speakerStatus === 2) {
          this.futureSpeakers.push(this.guests[i]);
        } else {
          this.pastSpeakers.push(this.guests[i]);
        }
        this.liveStream = this.featureSpeaker[0];
      }
    },

    getTimeToShow() {
      // Get the day of the week = 2
      this.dayOfWeek;
      // Get the current time = in date object
      this.currentDate;
      // Make sure the timezone is correct

      // Timezone varies depending on Daylight Savings

      // Compare with current time in timezone SF
      // var pacificTime = new Date("2020-04-13T00:00:00.000+08:00")

      // Get Time Until 10:30 AM PST
      // If time before 10:30am PST
      // If time 10:30 - 11           M-F (Skip) Show LIVE NOW
      // If time after 11 am PST      Subtract Hours from 24

      // If Monday,Tuesday,Wed,Thurs

      // If Friday Afternoon

      // If Saturday    Add + 2 days

      // If Sunday morning      Add + 1 day (Afternoon subtract from 24)

      // If
      // If between 10:30 - 11:00 Monday - Friday (Skip) Show LIVE NOW
      //
    },
    decrement() {
      this.time = this.time - 1;
    },
  },
};
</script>
